import Share from 'react-native-share'
import { DeepLinkingShare } from './createShareURL'

export const deepLinkingShare = async (
  deps,
  app,
  actionId,
  datasourceId,
  baseURL
) => {
  const url = await DeepLinkingShare.buildUrl(
    app,
    actionId,
    deps,
    false,
    datasourceId,
    baseURL
  )

  await Share.open({
    title: 'Share',
    failOnCancel: false,
    message: url,
  })
}
